import React from 'react'
import { Button } from '@material-ui/core';
import LinkButton from './LinkButton';
export default class HeaderListItem extends React.Component{
    constructor(props){
        super(props)
    }
    render(){
        // let borderBottom=(window.location.href.includes(this.props.url))?"1px solid black":"";
        let borderBottom='';
        return <div style={{padding:'0px 10px',borderBottom:borderBottom}}>
            <Button variant='text' color='primary'   onClick={this.props.onClick} style={{padding:0}}>
                    <LinkButton
                        url={this.props.url}
                        text={this.props.text}
                    />
            </Button>
        </div>
    }
}